var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-field-label-pane__filter" }, [
    _c(
      "div",
      {
        staticClass: "custom-field-label-pane__filter-input-container",
        class: {
          focus: _vm.focus,
        },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.filter,
              expression: "filter",
              modifiers: { trim: true },
            },
          ],
          attrs: {
            type: "text",
            placeholder: _vm.$t(
              "PtCustomFieldLabelPane.filter.searchFieldPlaceholder"
            ),
          },
          domProps: { value: _vm.filter },
          on: {
            focus: function ($event) {
              _vm.focus = true
            },
            blur: [
              function ($event) {
                _vm.focus = false
              },
              function ($event) {
                return _vm.$forceUpdate()
              },
            ],
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.filter = $event.target.value.trim()
            },
          },
        }),
        _vm.filter
          ? _c(
              "div",
              {
                staticClass:
                  "custom-field-label-pane__filter-input-container-counter",
              },
              [_vm._v(" " + _vm._s(_vm.count) + " ")]
            )
          : _vm._e(),
        _vm.filter
          ? _c("PtIcon", {
              attrs: { icon: "SolidCloseBig" },
              on: {
                click: function ($event) {
                  _vm.filter = ""
                },
              },
            })
          : _vm._e(),
        _c("PtIcon", { attrs: { icon: "SolidSearchLeft" } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }